// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarBreadcrumbs_container__q20tu","crumb":"SidebarBreadcrumbs_crumb__IpNTS"};